// Needs to start with '../../' due to file reusage in translation requests handling util
import { InternationalizationNameSpace } from '../../constants/internationalization-namespace';

export interface I18nFileLocation {
  ns: InternationalizationNameSpace;
  path: string;
  loader: (locale: string) => Promise<unknown>;
  translated?: boolean;
}

export const i18nFilesLocations: I18nFileLocation[] = [
  {
    ns: InternationalizationNameSpace.Legacy,
    path: '~/core/locales/',
    loader: (l) => import(`~/core/locales/legacy.${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.Common,
    path: '~/core/locales/common/',
    loader: (l) => import(`~/core/locales/common/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.InfoItemsHistory,
    path: '~/domain/inventory-list/locales/infoItemsHistory/',
    loader: (l) => import(`~/domain/inventory-list/locales/infoItemsHistory/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.UserSettings,
    path: '~/domain/settings/locales/userSettings/',
    loader: (l) => import(`~/domain/settings/locales/userSettings/${l}.json`),
    translated: false,
  },
  {
    ns: InternationalizationNameSpace.RoboticMowerDetails,
    path: '~/domain/roboticmower-details/locales/',
    loader: (l) => import(`~/domain/roboticmower-details/locales/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.Maintenance,
    path: '~/domain/maintenance/locales/',
    loader: (l) => import(`~/domain/maintenance/locales/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.CookiePolicy,
    path: '~/domain/legal/locales/cookiePolicy/',
    loader: (l) => import(`~/domain/legal/locales/cookiePolicy/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.AssetDetailsCommon,
    path: '~/domain/asset-details-common/locales/assetDetailsCommon/',
    loader: (l) => import(`~/domain/asset-details-common/locales/assetDetailsCommon/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.Dashboard,
    path: '~/domain/dashboard/locales/',
    loader: (l) => import(`~/domain/dashboard/locales/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.InventoryList,
    path: '~/domain/inventory-list/locales/inventoryList/',
    loader: (l) => import(`~/domain/inventory-list/locales/inventoryList/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.SignUp,
    path: '~/domain/sign-up/locales/signUp/',
    loader: (l) => import(`~/domain/sign-up/locales/signUp/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.AccessGroups,
    path: '~/domain/access-groups/locales/',
    loader: (l) => import(`~/domain/access-groups/locales/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.Login,
    path: '~/domain/auth/locales/login/',
    loader: (l) => import(`~/domain/auth/locales/login/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.InstallPrompt,
    path: '~/domain/install-prompt/locales/installPrompt/',
    loader: (l) => import(`~/domain/install-prompt/locales/installPrompt/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.DealerAccess,
    path: '~/components/containers/DealerAccessContainerV2/locales/',
    loader: (l) => import(`~/components/containers/DealerAccessContainerV2/locales/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.AssetTags,
    path: '~/domain/asset-details-common/locales/assetTags/',
    loader: (l) => import(`~/domain/asset-details-common/locales/assetTags/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.FilterPanel,
    path: '~/domain/inventory-list/locales/filterPanel/',
    loader: (l) => import(`~/domain/inventory-list/locales/filterPanel/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.GreenkeeperTool,
    path: '~/domain/greenkeeper-tool/locales/greenkeeperTool/',
    loader: (l) => import(`~/domain/greenkeeper-tool/locales/greenkeeperTool/${l}.json`),
  },
  {
    ns: InternationalizationNameSpace.RoboticMowersCuttingHeight,
    path: '~/domain/robotic-mowers/locales/cuttingHeight/',
    loader: (l) => import(`~/domain/robotic-mowers/locales/cuttingHeight/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.RoboticMowersSchedule,
    path: '~/domain/robotic-mowers/locales/schedule/',
    loader: (l) => import(`~/domain/robotic-mowers/locales/schedule/${l}.json`),
    translated: true,
  },
  {
    ns: InternationalizationNameSpace.RoboticMowers,
    path: '~/domain/robotic-mowers/locales/roboticMowers/',
    loader: (l) => import(`~/domain/robotic-mowers/locales/roboticMowers/${l}.json`),
    translated: true,
  },
];
